import { GAME_ID, REDUX_ACTIONS, MIN_TRIES_FOR_MASTERY } from '../../data/constants';
import { parseCharacters } from '../../lib/utilityFunctions';

const initState = {
  levelIndex: 0,
  progressAmount: 0,
  selectedDocumentId: -1,
  itemUuid: '',
  records: [],
  levelCharacters: [],
  levelDocuments: [],
  levelSuperlatives: {},
  isClosingStdItem: false,
  isBackButtonDisabled: false,
  wrongCount: 0,
  strikeCount: 0,
};

const roundPlayReducer = (state = initState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.SET_LEVEL_INDEX:
      return {
        ...state,
        levelIndex: payload,
      };

    case REDUX_ACTIONS.INITIALIZE_LEVEL: {
      const { characters, documents, superlatives } = payload;
      const levelCharacters = parseCharacters(characters, superlatives);
      return {
        ...state,
        progressAmount: 0,
        selectedDocumentId: -1,
        itemUuid: '',
        levelCharacters,
        levelDocuments: documents.map(document => ({
          ...document,
          isComplete: false,
        })),
        levelSuperlatives: superlatives,
        strikeCount: 0,
        records: [],
      };
    }

    case REDUX_ACTIONS.UPDATE_RECORDS:
      return {
        ...state,
        records: [...state.records, payload],
      };

    case REDUX_ACTIONS.INITIALIZE_STANDARD_ITEM:
      return {
        ...state,
        selectedDocumentId: payload.id,
        itemUuid: payload.uuid,
        isClosingStdItem: false,
        isBackButtonDisabled: false,
        wrongCount: 0,
      };

    case REDUX_ACTIONS.COMPLETE_STD_ITEM: {
      const { selectedCharacterId } = payload;
      const selectedDocument = state.levelDocuments.find(d => d.id === state.selectedDocumentId);
      const completedTraitText = selectedDocument.traits.find(t => t.isCorrect).text;
      return {
        ...state,
        levelDocuments: state.levelDocuments.map(document => ({
          ...document,
          isComplete: document.id === state.selectedDocumentId ? true : document.isComplete,
        })),
        levelCharacters: state.levelCharacters.map((character) => {
          if (character.id === selectedCharacterId) {
            return {
              ...character,
              correctTraits: character.correctTraits.map(
                trait => (trait.text === completedTraitText ? { ...trait, isCompleted: true } : trait),
              ),
            };
          }
          return character;
        }),
        progressAmount: 100 * state.levelDocuments.reduce(
          (total, current) => (current.isComplete ? total + 1 : total),
          1,
        ) / state.levelDocuments.length,
        isClosingStdItem: true,
      };
    }

    case REDUX_ACTIONS.FAIL_STD_ITEM:
      return {
        ...state,
        isClosingStdItem: true,
      };

    case REDUX_ACTIONS.INCREMENT_WRONG_COUNT: {
      const wrongCount = state.wrongCount + 1;
      return {
        ...state,
        wrongCount,
        isBackButtonDisabled: true,
        strikeCount: wrongCount === MIN_TRIES_FOR_MASTERY ? state.strikeCount + 1 : state.strikeCount,
      };
    }
    case REDUX_ACTIONS.MERGE_GAME_STATE: {
      const { roundPlay } = payload;
      if (roundPlay) {
        return {
          ...state,
          ...roundPlay,
        };
      }
      return state;
    }

    default:
      return state;
  }
};

export default roundPlayReducer;
